import BaseEndpoint from '@/api/endpoints/base-endpoint'

export default class UserRequestEndpoint extends BaseEndpoint {}
